import React, { useState, useEffect, useRef } from "react"
import classNames from "classnames"

function useIntersection(options) {
  const [observerEntry, setEntry] = useState({})
  const elRef = useRef()

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => setEntry(entries[0]),
      options
    )
    observer.observe(elRef.current)
    return () => observer.disconnect()
  }, [elRef])
  return { observerEntry, elRef }
}

const NoteIO = ({ visible, handleClick, children, sup }) => {
  const { observerEntry, elRef } = useIntersection({ threshold: 1 })

  return (
    <span
      ref={elRef}
      className={classNames("note", {
        visible: observerEntry.isIntersecting,
        pinned: visible && observerEntry.isIntersecting,
      })}
      onClick={handleClick}
    >
      <sup className="note__sup">{sup}</sup>
      <span className="note__body">
        <span className="note__wrap">
          <span>
            {sup}&nbsp;&nbsp;&nbsp;&nbsp;{children}
          </span>
        </span>
      </span>
    </span>
  )
}

class Note extends React.Component {
  state = {
    visible: false,
  }

  handleClick = () => this.setState({ visible: !this.state.visible })

  render() {
    return (
      <NoteIO
        sup={this.props.sup}
        // handleClick={this.handleClick}
        visible={this.state.visible}
      >
        {this.props.children}
      </NoteIO>
    )
  }
}

export default Note
